import {ModelMetadataOptionsDTOOptions} from 'hemwb-api';

export const isValidProperty = (
  property: string,
  options: ModelMetadataOptionsDTOOptions,
): property is keyof ModelMetadataOptionsDTOOptions => {
  return options.hasOwnProperty(property);
};
